import { RuleEvaluators } from "../types";

export const customisedContactDetails: RuleEvaluators["customisedContactDetails"] =
  (user, _action, { value: { teamUri } }) => {
    if (teamUri === user.teamUri) return true;

    return false;
  };
